import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const preFn = /* @__PURE__ */ createRecipe('pre', {}, [])

const preVariantMap = {}

const preVariantKeys = Object.keys(preVariantMap)

export const pre = /* @__PURE__ */ Object.assign(memo(preFn.recipeFn), {
  __recipe__: true,
  __name__: 'pre',
  __getCompoundVariantCss__: preFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: preVariantKeys,
  variantMap: preVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, preVariantKeys)
  },
  getVariantProps: preFn.getVariantProps,
})